import position from '../../styles/position';

const contentDiv = {
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: 10,
    height: '20px',
};

export default {
    content: {
        fontSize: 13,
        boxSizing: 'border-box',
        position: 'relative',
        whiteSpace: 'nowrap',
        background: '#f8f8f8',
        borderRadius: '20px!important',
        padding: '1px 10px 5px 5px',
    },
    contentDivText: {
        ...contentDiv,
    },

    contentDivTextTwoLines: {
        ...contentDiv,
    },
    clearButton: {
        cursor: 'pointer',
        marginTop: 5,
        marginLeft: 5,
        position: 'relative',
        float: 'right',
        fontSize: 10,
        marginRight: 5,
        top: 0,
    },
    block: {
        ...position.block,
        backgroundColor: 'none',
    },
    inlineBlock: {
        ...position.inlineBlock,
    },
    blockWithColor: {
        ...position.block,
        color: '#8f8f8f',
    },
    minusMarginLeft: {
        marginLeft: '-5px',
    },
    textAlignRight: {
        textAlign: 'right',
    },
    rightStyle: {
        maxWidth: 100,
        whiteSpace: 'initial',
    },
};
